module.exports = __webpack_public_path__ + "img/a2.34773cb8.png";